<template>
    <div>
        <client-modal :show="isShowingWelcomeSidebarPopup" @close="() => closeWelcomeSidebarPopup()">
            <div class="p-10 text-gray">
                <h3 class="font-averta text-2xl text-red mb-4">Dags för en ny kampanj?</h3>

                <p class="font-avertaLight text-gray block mb-4">Då har du kommit rätt! :) Som vanligt hittar du tips under "<icon name="info" class="inline" />" vid varje steg. Tänk på att du har möjlighet att testa dig fram till önskat utfall! Laborera med olika typer av erbjudanden och rabattsatser för att komma fram till vad som fungerar bäst. </p>

                <p class="font-avertaLight text-gray block mb-4">Vi vet av erfarenhet att det allt som oftast lönar sig att byta erbjudanden regelbundet. Gärna en gång i månaden! Du kan enkelt lägga upp flera erbjudanden vid samma tillfälle och styra start- och slutdatum, så de avlöser varandra. Lycka till! :)</p>

                <div class="flex">
                    <primary-button v-if="currentCreationStep !== null" @click="closeWelcomeSidebarPopup">Nu kör vi!</primary-button>
                    <primary-button v-if="currentCreationStep === null" @click="isShowingWelcomeSidebarPopup = false">Nu kör vi!</primary-button>

                    <secondary-button
                        v-if="currentCreationStep !== null"
                        @click="cancelCreation"
                        class="ml-auto">
                        Avbryt
                    </secondary-button>
                </div>
            </div>
        </client-modal>

        <client-modal :show="isShowingSettingsSidebarPopup" @close="closeSettingsSidebarPopup" :enableCloseButton="currentCreationStep === null">
            <div class="p-4 md:p-10">
                <div v-if="currentCreationStep === 'type' || currentCreationStep === null" class="md:flex md:flex-col mb-8 md:-mx-2">
                    <campaign-type
                        v-model:webshopUrl="form.url"
                        v-model:campaignType="form.type"
                        v-model:selectedCities="form.cities"
                        :availableCities="availableCities"
                        :availableTypes="availableTypes"
                        :edit-mode="false"
                        :errors="form.errors"></campaign-type>
                </div>

                <div v-if="currentCreationStep === 'coupon' || currentCreationStep === null" class="md:flex md:flex-col mb-8 md:-mx-2">
                    <coupon-code-type
                        :campaignType="form.type"
                        v-model:couponCode="form.coupon_code"
                        v-model:couponType="form.coupon_code_type_id"
                        :edit-mode="false"
                        :errors="form.errors"></coupon-code-type>
                </div>

                <div v-if="currentCreationStep === 'general' || currentCreationStep === null" :class="{ 'mb-8': currentCreationStep !== null }" class="md:flex md:flex-col md:-mx-2">
                    <general-settings
                        v-model:startDate="form.start_date"
                        v-model:endDate="form.end_date"
                        v-model:selectedCategories="form.categories"
                        v-model:isValentineCampaign="form.valentine"
                        v-model:isUsingNoEndDate="isUsingNoEndDate"
                        :availableCategories="availableCategories"
                        :errors="form.errors"></general-settings>
                </div>

                <div v-if="currentCreationStep === 'confirmation'" class="flex flex-col -mx-2 mb-8 items-center">
                    <h2 class="text-2xl mb-2 text-red font-averta">Bra jobbat!</h2>

                    <p class="text-center text-gray font-avertaLight my-2">
                        Då är grundinställningarna till kampanjen fixade och klara. Nu är det dags att ladda upp en kampanjbild + välja rubrik och beskrivning.
                    </p>
                </div>

                <div v-if="currentCreationStep === null" class="flex mt-6">
                    <primary-button
                        class="ml-auto"
                        @click="closeSettingsSidebarPopup">
                        Spara
                    </primary-button>
                </div>

                <div class="flex w-full" :class="{ 'justify-center': currentCreationStep === 'confirmation' }">
                    <button
                        v-if="currentCreationStep !== null && !['confirmation', 'type'].includes(currentCreationStep)"
                        @click="prevCreationStep"
                        class="transition-all text-sm ml-2 text-gray border border-gray rounded-md px-4 py-2 font-semibold tracking-wide text-center hover:bg-gray hover:text-white">
                        Tillbaka
                    </button>

                    <secondary-button
                        v-if="currentCreationStep !== null && currentCreationStep !== 'confirmation'"
                        @click="cancelCreation"
                        class="ml-auto mr-2">
                        Avbryt
                    </secondary-button>

                    <primary-button
                        v-if="currentCreationStep !== null"
                        @click="nextCreationStep">
                        <span v-if="currentCreationStep === 'confirmation'">Nu kör vi!</span>
                        <span v-else>Nästa</span>
                    </primary-button>
                </div>
            </div>
        </client-modal>

        <client-modal :full-page="true" :show="isShowingPreviewModal" @close="isShowingPreviewModal = false">
            <div class="p-6">
                <div class="bg-white rounded-md p-6">
                    <campaign-preview
                        ref="preview"
                        :data="previewData"
                        :company="company"
                        @close="isShowingPreviewModal = false"></campaign-preview>
                </div>
            </div>
        </client-modal>

        <div class="flex flex-col md:flex-row md:h-12 items-center mb-6 md:mb-2">
            <h2 class="text-md md:text-2xl text-red font-avertaBold"><span class="uppercase">Mina sidor Företag</span> / <span class="font-averta">Ny kampanj</span></h2>
        </div>

        <div class="text-sm text-gray mb-10 max-w-2xl">
            Dags för en ny kampanj? Då har du kommit rätt! :) Som vanligt hittar du tips under "<icon name="info" class="inline" />" vid varje steg. Tänk på att du har möjlighet att testa dig fram till önskat utfall! Laborera med olika typer av erbjudanden och rabattsatser för att... <a href="javascript:void(0)" @click="isShowingWelcomeSidebarPopup = true" class="underline">Läs mer</a>
        </div>

        <div class="bg-white my-6 w-full px-4 py-3 rounded-md shadow flex sticky top-[82px] z-[10]">
            <secondary-button @click="isShowingSettingsSidebarPopup = true">
                Inställningar
            </secondary-button>

            <secondary-button @click="startPreview" class="ml-2">
                Förhandsgranska
            </secondary-button>

            <primary-button :loading="form.processing" @click="createCampaign" class="ml-auto">
                Spara
            </primary-button>
        </div>

        <campaign-editor
            v-model:image="main_image"
            v-model:heading="form.heading"
            v-model:desc="form.description"
            @error-resolved="(field) => form.errors[field] = null"
            :errors="{
                heading: form.errors.heading,
                description: form.errors.description,
            }"></campaign-editor>
    </div>
</template>

<script>
import ClientLayout from '@/Layouts/Client';
import Popper from 'vue3-popper';
import ClientModal from '@/components/client/Modal';
import SidebarPopup from '@/components/client/SidebarPopup';
import CouponCodeType from '@/Pages/Client/Campaigns/CouponCodeType';
import CampaignType from '@/Pages/Client/Campaigns/CampaignType';
import GeneralSettings from '@/Pages/Client/Campaigns/GeneralSettings';
import CampaignEditor from '@/Pages/Client/Campaigns/CampaignEditor';
import CampaignPreview from '@/Pages/Client/Campaigns/Preview';
import { router } from '@inertiajs/vue3';
import PrimaryButton from '@/components/client/Buttons/PrimaryButton';
import SecondaryButton from '@/components/client/Buttons/SecondaryButton';

export default {
    props: ['company', 'availableCities', 'availableCategories', 'availableTypes'],

    layout: ClientLayout,

    components: {
        Popper, CouponCodeType, CampaignType, GeneralSettings, CampaignEditor, CampaignPreview, ClientModal, SidebarPopup, PrimaryButton, SecondaryButton
    },

    data() {
        return {
            isCreating: false,
            main_image: { cropper: null, image: null, image_crop: null, file: null, deleted: false, },
            isShowingPreviewModal: false,
            isShowingSettingsSidebarPopup: false,
            isShowingWelcomeSidebarPopup: false,
            previewData: {},
            currentCreationStep: 'type',
            isUsingNoEndDate: false,
            creationSteps: {
                type: {
                    next: 'coupon',
                    prev: null,
                    validate: () => {
                        const response = { fails: false, message: null };

                        if (!this.form.type) {
                            response.fails = true;
                            response.message = 'Välj typ av kampanj.';
                        }

                        if (this.form.type === 'webshop' && !this.form.url && response.fails !== true) {
                            response.fails = true;
                            response.message = 'Url till kampanjsida är obligatoriskt.';
                        }

                        if (this.form.type === 'local' && this.form.cities.length === 0 && response.fails !== true) {
                            response.fails = true;
                            response.message = 'Hoppsan! Du behöver välja minst en stad som din kampanj ska visas i. Du kan välja mellan de städer som ingår i din deal.';
                        }

                        return response;
                    }
                },
                coupon: {
                    next: 'general',
                    prev: 'type',
                    validate: () => {
                        const response = { fails: false, message: null };

                        if (!this.form.coupon_code_type_id) {
                            response.fails = true;
                            response.message = 'Ja hopp... innan vi kommer vidare behöver du ange vilken variant av kampanj du vill skapa :) Du kan läsa mer info om de olika alternativen om du klickar på dem.';
                        }

                        if (!this.form.coupon_code && response.fails !== true && this.form.coupon_code_type_id === 4) {
                            response.fails = true;
                            response.message = 'Hoppsan Kerstin! Du behöver skriva i länken till vart du vill att medlemmen ska komma när de klickar sig vidare.';
                        }

                        if (!this.form.coupon_code && response.fails !== true) {
                            response.fails = true;
                            response.message = 'Oups... Vi behöver en kampanjkod för att komma vidare...';
                        }

                        return response;
                    }
                },
                general: {
                    next: 'confirmation',
                    prev: 'coupon',
                    validate: () => {
                        const response = { fails: false, message: null };

                        if (!this.form.start_date) {
                            response.fails = true;
                            response.message = 'Åååh här saknar vi ett startdatum för att komma vidare. ';
                        }

                        if (!this.form.end_date && !this.isUsingNoEndDate && response.fails !== true) {
                            response.fails = true;
                            response.message = 'Vill du att kampanjen rullar på tillsvidare? Klicka isf i bocken "Tillsvidare". Välj annars vilken dag som är den sista kampanjen ska vara aktiv. ';
                        }

                        if (this.form.categories.length === 0 && response !== true) {
                            response.fails = true;
                            response.message = 'Då ska vi se... Vilken eller vilka kategorier tillhör kampanjen? ';
                        }

                        return response;
                    }
                },
                confirmation: {
                    next: null,
                },
            },
            form: this.$inertia.form({
                heading: null,
                start_date: null,
                end_date: null,
                description: null,
                url: null,
                cities: [],
                categories: [],
                type: null,
                coupon_code_type_id: null,
                coupon_code: null,
                valentine: false,
                main_image: { cropper: null, file: null, deleted: false, }
            }),
            removeBeforeEventListener: null,
        };
    },

    watch: {
        main_image: {
            deep: true,
            handler(currentValue, oldValue) {
                // Only set the required values to avoid large upload size
                this.form.main_image.cropper = currentValue.cropper;
                this.form.main_image.file = currentValue.file;
                this.form.main_image.deleted = currentValue.deleted;
            }
        }
    },

    created () {
        if (!this.welcomeSidebarPopupAlreadyVisited()) {
            this.isShowingWelcomeSidebarPopup = true;
        } else {
            this.isShowingSettingsSidebarPopup = true;
        }

        this.removeBeforeEventListener = router.on('before', (event) => {
            if (!this.isCreating && this.currentCreationStep === null && !confirm('Håll i hatten! Lämna utan att SPARA? Då kommer dina ändringar att försvinna....')) {
                event.preventDefault()
            }
        });

        this.form.cities = this.availableCities.map((c) => c.id);
        this.form.categories = this.availableCategories.map((c) => c.id);
        this.form.url = this.company.url;
    },

    beforeMount () {
        // this.form.type = 'local';
        // this.form.url = 'https://google.se';
        // this.isShowingSettingsSidebarPopup = true;
        // this.form.heading = 'lorem ipsum klasd kask dkak k';
        // this.form.description = '123 1 3123 1231 3123 1 313 123 1 312 3';
        // this.form.coupon_code_type_id = 5;
        // this.form.coupon_code = 'coupon';
        // this.form.start_date = '2021-10-12 00:00:00';
        // this.form.end_date = '2021-10-16 00:00:00';
        // this.currentCreationStep = 'coupon';
    },

    beforeUnmount () {
        this.removeBeforeEventListener();
    },

    methods: {
        welcomeSidebarPopupAlreadyVisited() {
            return window.localStorage.getItem('fk_client:welcomeSidebarVisited');
        },

        closeWelcomeSidebarPopup() {
            if (this.currentCreationStep !== null) {
                this.isShowingWelcomeSidebarPopup = false;
                this.isShowingSettingsSidebarPopup = true;
            } else {
                this.isShowingWelcomeSidebarPopup = false;
            }
        },

        cancelCreation() {
            const confirmation = confirm('Är du säker på att du vill avbryta?');

            if (!confirmation) {
                return;
            }

            this.$inertia.visit(`/kund/${this.company.slug}/kampanjer`);
        },

        prevCreationStep() {
            const currentStep = this.creationSteps[this.currentCreationStep];
            this.currentCreationStep = currentStep['prev'];
            this.closeSettingsSidebarPopup();
        },

        nextCreationStep() {
            const currentStep = this.creationSteps[this.currentCreationStep];

            if (currentStep.validate) {
                const validator = currentStep.validate();

                if (validator.fails) {
                    alert(validator.message);

                    return;
                }
            }

            this.currentCreationStep = currentStep['next'];
            this.closeSettingsSidebarPopup();
        },

        closeSettingsSidebarPopup() {
            if (this.currentCreationStep === null) {
                window.localStorage.setItem('fk_client:welcomeSidebarVisited', true);
                this.isShowingSettingsSidebarPopup = false;
            }
        },

        startPreview() {
            if (!this.form.heading || !this.form.description) {
                alert('Du behöver ange rubrik och beskrivning först.');
                return;
            }

            this.previewData = {
                heading: this.form.heading,
                description: this.form.description,
                main_image: this.main_image.image_crop,
                uri: 'campaign-preview-before-creation',
            };

            this.isShowingPreviewModal = true;

            setTimeout(() => this.$refs.preview.createPreview(), 300);
        },

        createCampaign() {
            this.isCreating = true;

            if (this.form.processing) {
                return;
            }

            this.form.post(`/kund/${this.company.slug}/lagg-till-kampanj`, {
                preserveScroll: true,
                forceFormData: true,
                onSuccess: () => {
                    this.$moshaToast('Din kampanj har skapats!', {
                        type: 'success',
                        timeout: 2000,
                    });
                },
                onError: () => {
                    this.isCreating = false;
                }
            });
        },
    }
}
</script>
